import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const ActionButton = (props) => {
  const onClick = () => {
    if (!props.isLoading && props.onClick) {
      props.onClick();
    }
  };

  let buttonClassNames = 'default-button';
  let titleClassNames = 'btn-title';

  if (props.disabled) {
    buttonClassNames += ' disabled';
  }

  if (props.className) {
    buttonClassNames += ` ${props.className}`;
  }

  if (props.isLoading) {
    titleClassNames += ' hidden';
  }

  return (
    <>
      <button
        className={buttonClassNames}
        onClick={onClick}
        title={props.title}
        disabled={props.disabled}
        // eslint-disable-next-line react/button-has-type
        type={props.type}
      >
        <If condition={props.isLoading}>
          <div className="spinner-border text-light" role="status" />
        </If>
        <span className={titleClassNames}>
          <If condition={props.logoImgSrc}>
            <img className="icon action-button-icon" src={props.logoImgSrc} alt={props.imgLogoAlt} />
          </If>
          {props.title}
        </span>
      </button>
    </>
  );
};

ActionButton.propTypes = {
  // Akcja klikniecia przycisku
  onClick: PropTypes.func,
  // Flaga czy ma zostać wyświetlony spinner
  isLoading: PropTypes.bool,
  // Czy przycisk zablokowany
  disabled: PropTypes.bool,
  // Tekst przycisku
  title: PropTypes.string,
  // Dodatkowe klasy
  className: PropTypes.string,
  // Source do logo
  logoImgSrc: PropTypes.string,
  // Alt to zdjęcia logo
  imgLogoAlt: PropTypes.string,
  // Typ przycisku
  type: PropTypes.string,
};

ActionButton.defaultProps = {
  isLoading: false,
  disabled: false,
  title: null,
  className: null,
  logoImgSrc: null,
  imgLogoAlt: '',
  type: 'button',
  onClick: null,
};

export default ActionButton;
